/**
 * Generated by orval v8.19.0 🍺
 * Do not edit manually.
 * Payin admin
 * Payin application
 * OpenAPI spec version: 1.0
 */
import { useQuery } from '@tanstack/react-query';
import {
    type DataTag,
    type DefinedInitialDataOptions,
    type DefinedUseQueryResult,
    type QueryClient,
    type QueryFunction,
    type QueryKey,
    type UndefinedInitialDataOptions,
    type UseQueryOptions,
    type UseQueryResult,
} from '@tanstack/react-query';
import { payinKyMutator } from '../../shared/api/kyMutator';
import { type ErrorType, type BodyType } from '../../shared/api/kyMutator';
import {
    type AdminPayinOrderServiceCountOrdersParams,
    type AdminPayinOrderServiceGetOrderChecksParams,
    type AdminPayinOrderServiceGetOrderEventsParams,
    type AdminPayinOrderServiceGetOrderParams,
    type AdminPayinOrderServiceListOrdersParams,
    type GoogleRpcStatus,
    type PayinAdminOrderV1ApproveOrderRequest,
    type PayinAdminOrderV1ApproveOrderResponse,
    type PayinAdminOrderV1CountOrdersResponse,
    type PayinAdminOrderV1DeclineOrderRequest,
    type PayinAdminOrderV1DeclineOrderResponse,
    type PayinAdminOrderV1GetOrderChecksResponse,
    type PayinAdminOrderV1GetOrderEventsResponse,
    type PayinAdminOrderV1GetOrderResponse,
    type PayinAdminOrderV1ListOrdersResponse,
} from './model';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
    const result = { queryKey } as T & { queryKey: K };

    for (const key of Object.keys(query)) {
        // The explicit queryKey always wins, matching the previous
        // `{ ...query, queryKey }` spread where it was set last.
        if (key === 'queryKey') { continue; }

        Object.defineProperty(result, key, {
            enumerable: true,
            configurable: true,
            get: () => (query as Record<string, unknown>)[key],
        });
    }

    return result;
};

export const getAdminPayinOrderServiceGetOrderUrl = (params?: AdminPayinOrderServiceGetOrderParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/v1/order?${stringifiedParams}` : '/v1/order';
};

export const adminPayinOrderServiceGetOrder = async (
    params?: AdminPayinOrderServiceGetOrderParams,
    options?: RequestInit,
): Promise<PayinAdminOrderV1GetOrderResponse> => {
    return payinKyMutator<PayinAdminOrderV1GetOrderResponse>(getAdminPayinOrderServiceGetOrderUrl(params), {
        ...options,
        method: 'GET',
    });
};

export const getAdminPayinOrderServiceGetOrderQueryKey = (params?: AdminPayinOrderServiceGetOrderParams) => {
    return ['/v1/order', ...(params ? [params] : [])] as const;
};

export const getAdminPayinOrderServiceGetOrderQueryOptions = <
    TData = Awaited<ReturnType<typeof adminPayinOrderServiceGetOrder>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayinOrderServiceGetOrderParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayinOrderServiceGetOrder>>, TError, TData>>;
        request?: SecondParameter<typeof payinKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getAdminPayinOrderServiceGetOrderQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPayinOrderServiceGetOrder>>> = ({ signal }) =>
        adminPayinOrderServiceGetOrder(params, { signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof adminPayinOrderServiceGetOrder>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminPayinOrderServiceGetOrderQueryResult = NonNullable<
    Awaited<ReturnType<typeof adminPayinOrderServiceGetOrder>>
>;
export type AdminPayinOrderServiceGetOrderQueryError = ErrorType<GoogleRpcStatus>;

export function useAdminPayinOrderServiceGetOrder<
    TData = Awaited<ReturnType<typeof adminPayinOrderServiceGetOrder>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params: undefined | AdminPayinOrderServiceGetOrderParams,
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayinOrderServiceGetOrder>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayinOrderServiceGetOrder>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayinOrderServiceGetOrder>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayinOrderServiceGetOrder<
    TData = Awaited<ReturnType<typeof adminPayinOrderServiceGetOrder>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayinOrderServiceGetOrderParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayinOrderServiceGetOrder>>, TError, TData>> &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayinOrderServiceGetOrder>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayinOrderServiceGetOrder>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayinOrderServiceGetOrder<
    TData = Awaited<ReturnType<typeof adminPayinOrderServiceGetOrder>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayinOrderServiceGetOrderParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayinOrderServiceGetOrder>>, TError, TData>>;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useAdminPayinOrderServiceGetOrder<
    TData = Awaited<ReturnType<typeof adminPayinOrderServiceGetOrder>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayinOrderServiceGetOrderParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayinOrderServiceGetOrder>>, TError, TData>>;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getAdminPayinOrderServiceGetOrderQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getAdminPayinOrderServiceGetOrderChecksUrl = (params?: AdminPayinOrderServiceGetOrderChecksParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/v1/order/checks?${stringifiedParams}` : '/v1/order/checks';
};

export const adminPayinOrderServiceGetOrderChecks = async (
    params?: AdminPayinOrderServiceGetOrderChecksParams,
    options?: RequestInit,
): Promise<PayinAdminOrderV1GetOrderChecksResponse> => {
    return payinKyMutator<PayinAdminOrderV1GetOrderChecksResponse>(getAdminPayinOrderServiceGetOrderChecksUrl(params), {
        ...options,
        method: 'GET',
    });
};

export const getAdminPayinOrderServiceGetOrderChecksQueryKey = (
    params?: AdminPayinOrderServiceGetOrderChecksParams,
) => {
    return ['/v1/order/checks', ...(params ? [params] : [])] as const;
};

export const getAdminPayinOrderServiceGetOrderChecksQueryOptions = <
    TData = Awaited<ReturnType<typeof adminPayinOrderServiceGetOrderChecks>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayinOrderServiceGetOrderChecksParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayinOrderServiceGetOrderChecks>>, TError, TData>
        >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getAdminPayinOrderServiceGetOrderChecksQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPayinOrderServiceGetOrderChecks>>> = ({ signal }) =>
        adminPayinOrderServiceGetOrderChecks(params, { signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof adminPayinOrderServiceGetOrderChecks>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminPayinOrderServiceGetOrderChecksQueryResult = NonNullable<
    Awaited<ReturnType<typeof adminPayinOrderServiceGetOrderChecks>>
>;
export type AdminPayinOrderServiceGetOrderChecksQueryError = ErrorType<GoogleRpcStatus>;

export function useAdminPayinOrderServiceGetOrderChecks<
    TData = Awaited<ReturnType<typeof adminPayinOrderServiceGetOrderChecks>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params: undefined | AdminPayinOrderServiceGetOrderChecksParams,
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayinOrderServiceGetOrderChecks>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayinOrderServiceGetOrderChecks>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayinOrderServiceGetOrderChecks>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayinOrderServiceGetOrderChecks<
    TData = Awaited<ReturnType<typeof adminPayinOrderServiceGetOrderChecks>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayinOrderServiceGetOrderChecksParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayinOrderServiceGetOrderChecks>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayinOrderServiceGetOrderChecks>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayinOrderServiceGetOrderChecks>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayinOrderServiceGetOrderChecks<
    TData = Awaited<ReturnType<typeof adminPayinOrderServiceGetOrderChecks>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayinOrderServiceGetOrderChecksParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayinOrderServiceGetOrderChecks>>, TError, TData>
        >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useAdminPayinOrderServiceGetOrderChecks<
    TData = Awaited<ReturnType<typeof adminPayinOrderServiceGetOrderChecks>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayinOrderServiceGetOrderChecksParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayinOrderServiceGetOrderChecks>>, TError, TData>
        >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getAdminPayinOrderServiceGetOrderChecksQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getAdminPayinOrderServiceCountOrdersUrl = (params?: AdminPayinOrderServiceCountOrdersParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = [
            'filter.statuses',
            'filter.publicStatuses',
            'filter.requisiteSuffixes',
            'filter.currency',
        ];

        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });

            return;
        }

        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/v1/order/count?${stringifiedParams}` : '/v1/order/count';
};

export const adminPayinOrderServiceCountOrders = async (
    params?: AdminPayinOrderServiceCountOrdersParams,
    options?: RequestInit,
): Promise<PayinAdminOrderV1CountOrdersResponse> => {
    return payinKyMutator<PayinAdminOrderV1CountOrdersResponse>(getAdminPayinOrderServiceCountOrdersUrl(params), {
        ...options,
        method: 'GET',
    });
};

export const getAdminPayinOrderServiceCountOrdersQueryKey = (params?: AdminPayinOrderServiceCountOrdersParams) => {
    return ['/v1/order/count', ...(params ? [params] : [])] as const;
};

export const getAdminPayinOrderServiceCountOrdersQueryOptions = <
    TData = Awaited<ReturnType<typeof adminPayinOrderServiceCountOrders>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayinOrderServiceCountOrdersParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayinOrderServiceCountOrders>>, TError, TData>>;
        request?: SecondParameter<typeof payinKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getAdminPayinOrderServiceCountOrdersQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPayinOrderServiceCountOrders>>> = ({ signal }) =>
        adminPayinOrderServiceCountOrders(params, { signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof adminPayinOrderServiceCountOrders>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminPayinOrderServiceCountOrdersQueryResult = NonNullable<
    Awaited<ReturnType<typeof adminPayinOrderServiceCountOrders>>
>;
export type AdminPayinOrderServiceCountOrdersQueryError = ErrorType<GoogleRpcStatus>;

export function useAdminPayinOrderServiceCountOrders<
    TData = Awaited<ReturnType<typeof adminPayinOrderServiceCountOrders>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params: undefined | AdminPayinOrderServiceCountOrdersParams,
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayinOrderServiceCountOrders>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayinOrderServiceCountOrders>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayinOrderServiceCountOrders>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayinOrderServiceCountOrders<
    TData = Awaited<ReturnType<typeof adminPayinOrderServiceCountOrders>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayinOrderServiceCountOrdersParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayinOrderServiceCountOrders>>, TError, TData>> &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayinOrderServiceCountOrders>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayinOrderServiceCountOrders>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayinOrderServiceCountOrders<
    TData = Awaited<ReturnType<typeof adminPayinOrderServiceCountOrders>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayinOrderServiceCountOrdersParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayinOrderServiceCountOrders>>, TError, TData>>;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useAdminPayinOrderServiceCountOrders<
    TData = Awaited<ReturnType<typeof adminPayinOrderServiceCountOrders>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayinOrderServiceCountOrdersParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayinOrderServiceCountOrders>>, TError, TData>>;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getAdminPayinOrderServiceCountOrdersQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getAdminPayinOrderServiceGetOrderEventsUrl = (params?: AdminPayinOrderServiceGetOrderEventsParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/v1/order/events?${stringifiedParams}` : '/v1/order/events';
};

export const adminPayinOrderServiceGetOrderEvents = async (
    params?: AdminPayinOrderServiceGetOrderEventsParams,
    options?: RequestInit,
): Promise<PayinAdminOrderV1GetOrderEventsResponse> => {
    return payinKyMutator<PayinAdminOrderV1GetOrderEventsResponse>(getAdminPayinOrderServiceGetOrderEventsUrl(params), {
        ...options,
        method: 'GET',
    });
};

export const getAdminPayinOrderServiceGetOrderEventsQueryKey = (
    params?: AdminPayinOrderServiceGetOrderEventsParams,
) => {
    return ['/v1/order/events', ...(params ? [params] : [])] as const;
};

export const getAdminPayinOrderServiceGetOrderEventsQueryOptions = <
    TData = Awaited<ReturnType<typeof adminPayinOrderServiceGetOrderEvents>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayinOrderServiceGetOrderEventsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayinOrderServiceGetOrderEvents>>, TError, TData>
        >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getAdminPayinOrderServiceGetOrderEventsQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPayinOrderServiceGetOrderEvents>>> = ({ signal }) =>
        adminPayinOrderServiceGetOrderEvents(params, { signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof adminPayinOrderServiceGetOrderEvents>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminPayinOrderServiceGetOrderEventsQueryResult = NonNullable<
    Awaited<ReturnType<typeof adminPayinOrderServiceGetOrderEvents>>
>;
export type AdminPayinOrderServiceGetOrderEventsQueryError = ErrorType<GoogleRpcStatus>;

export function useAdminPayinOrderServiceGetOrderEvents<
    TData = Awaited<ReturnType<typeof adminPayinOrderServiceGetOrderEvents>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params: undefined | AdminPayinOrderServiceGetOrderEventsParams,
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayinOrderServiceGetOrderEvents>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayinOrderServiceGetOrderEvents>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayinOrderServiceGetOrderEvents>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayinOrderServiceGetOrderEvents<
    TData = Awaited<ReturnType<typeof adminPayinOrderServiceGetOrderEvents>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayinOrderServiceGetOrderEventsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayinOrderServiceGetOrderEvents>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayinOrderServiceGetOrderEvents>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayinOrderServiceGetOrderEvents>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayinOrderServiceGetOrderEvents<
    TData = Awaited<ReturnType<typeof adminPayinOrderServiceGetOrderEvents>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayinOrderServiceGetOrderEventsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayinOrderServiceGetOrderEvents>>, TError, TData>
        >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useAdminPayinOrderServiceGetOrderEvents<
    TData = Awaited<ReturnType<typeof adminPayinOrderServiceGetOrderEvents>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayinOrderServiceGetOrderEventsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayinOrderServiceGetOrderEvents>>, TError, TData>
        >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getAdminPayinOrderServiceGetOrderEventsQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getAdminPayinOrderServiceListOrdersUrl = (params?: AdminPayinOrderServiceListOrdersParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = [
            'filter.statuses',
            'filter.publicStatuses',
            'filter.requisiteSuffixes',
            'filter.currency',
        ];

        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });

            return;
        }

        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/v1/orders?${stringifiedParams}` : '/v1/orders';
};

export const adminPayinOrderServiceListOrders = async (
    params?: AdminPayinOrderServiceListOrdersParams,
    options?: RequestInit,
): Promise<PayinAdminOrderV1ListOrdersResponse> => {
    return payinKyMutator<PayinAdminOrderV1ListOrdersResponse>(getAdminPayinOrderServiceListOrdersUrl(params), {
        ...options,
        method: 'GET',
    });
};

export const getAdminPayinOrderServiceListOrdersQueryKey = (params?: AdminPayinOrderServiceListOrdersParams) => {
    return ['/v1/orders', ...(params ? [params] : [])] as const;
};

export const getAdminPayinOrderServiceListOrdersQueryOptions = <
    TData = Awaited<ReturnType<typeof adminPayinOrderServiceListOrders>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayinOrderServiceListOrdersParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayinOrderServiceListOrders>>, TError, TData>>;
        request?: SecondParameter<typeof payinKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getAdminPayinOrderServiceListOrdersQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPayinOrderServiceListOrders>>> = ({ signal }) =>
        adminPayinOrderServiceListOrders(params, { signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof adminPayinOrderServiceListOrders>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminPayinOrderServiceListOrdersQueryResult = NonNullable<
    Awaited<ReturnType<typeof adminPayinOrderServiceListOrders>>
>;
export type AdminPayinOrderServiceListOrdersQueryError = ErrorType<GoogleRpcStatus>;

export function useAdminPayinOrderServiceListOrders<
    TData = Awaited<ReturnType<typeof adminPayinOrderServiceListOrders>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params: undefined | AdminPayinOrderServiceListOrdersParams,
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayinOrderServiceListOrders>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayinOrderServiceListOrders>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayinOrderServiceListOrders>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayinOrderServiceListOrders<
    TData = Awaited<ReturnType<typeof adminPayinOrderServiceListOrders>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayinOrderServiceListOrdersParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayinOrderServiceListOrders>>, TError, TData>> &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayinOrderServiceListOrders>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayinOrderServiceListOrders>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayinOrderServiceListOrders<
    TData = Awaited<ReturnType<typeof adminPayinOrderServiceListOrders>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayinOrderServiceListOrdersParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayinOrderServiceListOrders>>, TError, TData>>;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useAdminPayinOrderServiceListOrders<
    TData = Awaited<ReturnType<typeof adminPayinOrderServiceListOrders>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayinOrderServiceListOrdersParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayinOrderServiceListOrders>>, TError, TData>>;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getAdminPayinOrderServiceListOrdersQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getAdminPayinOrderServiceApproveOrderUrl = () => {
    return '/v1/orders/approve';
};

/**
 * @summary Для ордеров в статусе STATUS_ON_INVESTIGATION.
Завершает расследование в пользу мерчанта:
trader order -> STATUS_ON_INVESTIGATION_APPROVE,
merchant order -> STATUS_INVESTIGATION_APPROVED.
 */
export const adminPayinOrderServiceApproveOrder = async (
    payinAdminOrderV1ApproveOrderRequest: PayinAdminOrderV1ApproveOrderRequest,
    options?: RequestInit,
): Promise<PayinAdminOrderV1ApproveOrderResponse> => {
    return payinKyMutator<PayinAdminOrderV1ApproveOrderResponse>(getAdminPayinOrderServiceApproveOrderUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(payinAdminOrderV1ApproveOrderRequest),
    });
};

export const getAdminPayinOrderServiceApproveOrderQueryKey = (
    payinAdminOrderV1ApproveOrderRequest?: BodyType<PayinAdminOrderV1ApproveOrderRequest>,
) => {
    return ['POST', '/v1/orders/approve', payinAdminOrderV1ApproveOrderRequest] as const;
};

export const getAdminPayinOrderServiceApproveOrderQueryOptions = <
    TData = Awaited<ReturnType<typeof adminPayinOrderServiceApproveOrder>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payinAdminOrderV1ApproveOrderRequest: BodyType<PayinAdminOrderV1ApproveOrderRequest>,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayinOrderServiceApproveOrder>>, TError, TData>>;
        request?: SecondParameter<typeof payinKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getAdminPayinOrderServiceApproveOrderQueryKey(payinAdminOrderV1ApproveOrderRequest);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPayinOrderServiceApproveOrder>>> = ({ signal }) =>
        adminPayinOrderServiceApproveOrder(payinAdminOrderV1ApproveOrderRequest, { signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof adminPayinOrderServiceApproveOrder>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminPayinOrderServiceApproveOrderQueryResult = NonNullable<
    Awaited<ReturnType<typeof adminPayinOrderServiceApproveOrder>>
>;
export type AdminPayinOrderServiceApproveOrderQueryError = ErrorType<GoogleRpcStatus>;

export function useAdminPayinOrderServiceApproveOrder<
    TData = Awaited<ReturnType<typeof adminPayinOrderServiceApproveOrder>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payinAdminOrderV1ApproveOrderRequest: BodyType<PayinAdminOrderV1ApproveOrderRequest>,
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayinOrderServiceApproveOrder>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayinOrderServiceApproveOrder>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayinOrderServiceApproveOrder>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayinOrderServiceApproveOrder<
    TData = Awaited<ReturnType<typeof adminPayinOrderServiceApproveOrder>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payinAdminOrderV1ApproveOrderRequest: BodyType<PayinAdminOrderV1ApproveOrderRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayinOrderServiceApproveOrder>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayinOrderServiceApproveOrder>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayinOrderServiceApproveOrder>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayinOrderServiceApproveOrder<
    TData = Awaited<ReturnType<typeof adminPayinOrderServiceApproveOrder>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payinAdminOrderV1ApproveOrderRequest: BodyType<PayinAdminOrderV1ApproveOrderRequest>,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayinOrderServiceApproveOrder>>, TError, TData>>;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Для ордеров в статусе STATUS_ON_INVESTIGATION.
Завершает расследование в пользу мерчанта:
trader order -> STATUS_ON_INVESTIGATION_APPROVE,
merchant order -> STATUS_INVESTIGATION_APPROVED.
 */

export function useAdminPayinOrderServiceApproveOrder<
    TData = Awaited<ReturnType<typeof adminPayinOrderServiceApproveOrder>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payinAdminOrderV1ApproveOrderRequest: BodyType<PayinAdminOrderV1ApproveOrderRequest>,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayinOrderServiceApproveOrder>>, TError, TData>>;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getAdminPayinOrderServiceApproveOrderQueryOptions(
        payinAdminOrderV1ApproveOrderRequest,
        options,
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getAdminPayinOrderServiceDeclineOrderUrl = () => {
    return '/v1/orders/decline';
};

/**
 * @summary Для ордеров в статусе STATUS_ON_INVESTIGATION.
Завершает расследование в пользу трейдера:
trader order -> STATUS_ON_INVESTIGATION_DECLINED,
merchant order -> STATUS_INVESTIGATION_REJECTED.
 */
export const adminPayinOrderServiceDeclineOrder = async (
    payinAdminOrderV1DeclineOrderRequest: PayinAdminOrderV1DeclineOrderRequest,
    options?: RequestInit,
): Promise<PayinAdminOrderV1DeclineOrderResponse> => {
    return payinKyMutator<PayinAdminOrderV1DeclineOrderResponse>(getAdminPayinOrderServiceDeclineOrderUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(payinAdminOrderV1DeclineOrderRequest),
    });
};

export const getAdminPayinOrderServiceDeclineOrderQueryKey = (
    payinAdminOrderV1DeclineOrderRequest?: BodyType<PayinAdminOrderV1DeclineOrderRequest>,
) => {
    return ['POST', '/v1/orders/decline', payinAdminOrderV1DeclineOrderRequest] as const;
};

export const getAdminPayinOrderServiceDeclineOrderQueryOptions = <
    TData = Awaited<ReturnType<typeof adminPayinOrderServiceDeclineOrder>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payinAdminOrderV1DeclineOrderRequest: BodyType<PayinAdminOrderV1DeclineOrderRequest>,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayinOrderServiceDeclineOrder>>, TError, TData>>;
        request?: SecondParameter<typeof payinKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getAdminPayinOrderServiceDeclineOrderQueryKey(payinAdminOrderV1DeclineOrderRequest);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPayinOrderServiceDeclineOrder>>> = ({ signal }) =>
        adminPayinOrderServiceDeclineOrder(payinAdminOrderV1DeclineOrderRequest, { signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof adminPayinOrderServiceDeclineOrder>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminPayinOrderServiceDeclineOrderQueryResult = NonNullable<
    Awaited<ReturnType<typeof adminPayinOrderServiceDeclineOrder>>
>;
export type AdminPayinOrderServiceDeclineOrderQueryError = ErrorType<GoogleRpcStatus>;

export function useAdminPayinOrderServiceDeclineOrder<
    TData = Awaited<ReturnType<typeof adminPayinOrderServiceDeclineOrder>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payinAdminOrderV1DeclineOrderRequest: BodyType<PayinAdminOrderV1DeclineOrderRequest>,
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayinOrderServiceDeclineOrder>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayinOrderServiceDeclineOrder>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayinOrderServiceDeclineOrder>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayinOrderServiceDeclineOrder<
    TData = Awaited<ReturnType<typeof adminPayinOrderServiceDeclineOrder>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payinAdminOrderV1DeclineOrderRequest: BodyType<PayinAdminOrderV1DeclineOrderRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayinOrderServiceDeclineOrder>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayinOrderServiceDeclineOrder>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayinOrderServiceDeclineOrder>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayinOrderServiceDeclineOrder<
    TData = Awaited<ReturnType<typeof adminPayinOrderServiceDeclineOrder>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payinAdminOrderV1DeclineOrderRequest: BodyType<PayinAdminOrderV1DeclineOrderRequest>,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayinOrderServiceDeclineOrder>>, TError, TData>>;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Для ордеров в статусе STATUS_ON_INVESTIGATION.
Завершает расследование в пользу трейдера:
trader order -> STATUS_ON_INVESTIGATION_DECLINED,
merchant order -> STATUS_INVESTIGATION_REJECTED.
 */

export function useAdminPayinOrderServiceDeclineOrder<
    TData = Awaited<ReturnType<typeof adminPayinOrderServiceDeclineOrder>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payinAdminOrderV1DeclineOrderRequest: BodyType<PayinAdminOrderV1DeclineOrderRequest>,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayinOrderServiceDeclineOrder>>, TError, TData>>;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getAdminPayinOrderServiceDeclineOrderQueryOptions(
        payinAdminOrderV1DeclineOrderRequest,
        options,
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}
